import { updateLoadingCount } from '../reducer/CommonSlice'
import { fetchApi } from '../services/fetch-services'
import store from '../store'
const baseURL = process.env.REACT_APP_BASE_API_URL

export const getCustomerPOVData = async (data) => {
  store.dispatch(updateLoadingCount(true))
  const response = await fetchApi({
    header: {},
    data,
    method: 'POST',
    url: `${baseURL}/calculation_summary/getCustomerPOV`
  })
  store.dispatch(updateLoadingCount(false))
  return response
}

export const getCustomerPOVPotentialData = async (data) => {
  const response = await fetchApi({
    header: {},
    data,
    method: 'POST',
    url: `${baseURL}/calculation_summary/getCustomerPOVPotential`
  })

  return response
}
